import { AppStore } from '../../../AppState/AppStore'
import { ServiceSelectors } from '../StoreAdapter'

export const useServiceSelector = (entityId: string) => {
  const entityState = ServiceSelectors.selectById(AppStore.getState(), entityId)

  return entityState
}
